function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M236.6 1.4c.9 6.7 1.2 7.2 2.8 20-1.2 7.3-3.9 10.2-5.9 15.3-74.6.8-199.2-1.2-223.9 0-2.2-.3-4.5-.4-6.7-1.3-2.4-1.2-1.9-10-2.7-15 4-2.1 1.6-5.6.1-9V8.8c2-1 2.4-2.4 3.1-3.8C4.7.5 20 1.2 32.3.6 182.2-.6 153.7 4.1 212.9.1z",
  fill: "#c90c0f"
});

function SvgBandeauRouge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 239.2 37"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMzkuMiAzNyI+PHBhdGggZD0iTTIzNi42IDEuNGMuOSA2LjcgMS4yIDcuMiAyLjggMjAtMS4yIDcuMy0zLjkgMTAuMi01LjkgMTUuMy03NC42LjgtMTk5LjItMS4yLTIyMy45IDAtMi4yLS4zLTQuNS0uNC02LjctMS4zLTIuNC0xLjItMS45LTEwLTIuNy0xNSA0LTIuMSAxLjYtNS42LjEtOVY4LjhjMi0xIDIuNC0yLjQgMy4xLTMuOEM0LjcuNSAyMCAxLjIgMzIuMy42IDE4Mi4yLS42IDE1My43IDQuMSAyMTIuOS4xeiIgZmlsbD0iI2M5MGMwZiIvPjwvc3ZnPg==";
export { SvgBandeauRouge as ReactComponent };